export default {
  // 模式
  "common.mode.auto": "स्वयंउत्पादित ऊर्जा स्वयंप्रयोग",
  "common.mode.economy": "आर्थिक मोड",
  "common.mode.exigency": "आपत्कालीन मोड",

  // 设备
  "common.grid": "विद्युत जाळी",
  "common.evChargers": "इलेक्ट्रिक वाहन चार्जर्स",
  "common.evCharger": "इलेक्ट्रिक वाहन चार्जर",
  "common.pv": "फोटोवोल्टिक (PV)",
  "common.inverter": "इन्वर्टर",
  "common.pcs": "इन्वर्टर + बॅटरी",
  "common.terminal": "टर्मिनल डिवाइस",
  "common.airc": "एअर कंडिशनर",
  "common.engine": "इंजिन",
  "common.battery": "बॅटरी",
  "common.metter": "विद्युत मीटर",
  "common.other": "इतर",
  "common.power": "शक्ती",
  "common.powerTotal": "एकूण शक्ती",
  "common.voltage": "व्होल्टेज",
  "common.electricity": "विद्युत",
  "common.current": "धारा",
  "common.homeUsage": "घराचा एकूण वापर",
  "common.battery.power": "बॅटरीची शक्ती",

  // 数据
  "common.noDataAvailable": "सध्या डेटा उपलब्ध नाही~",
  "common.tips": "सुझाव",
  "common.reset": "रीसेट करा",
  "common.currencyUnit": "¥",
  "common.submiting": "सबमिट करत आहे... कृपया प्रतीक्षा करा...",
  "common.close": "बंद करा",
  "common.from": "पासून",
  "common.useIn": "मध्ये वापरण्यासाठी",
  "common.energyPercent": "ऊर्जा प्रवाहाचा टक्का",
  "common.dataFlow": "डेटा प्रवाह",
  "common.getDataIng": "डेटा प्राप्त करत आहे... कृपया प्रतीक्षा करा...",
  "common.pageLoading": "पृष्ठाचा सामग्री लोड होत आहे... कृपया प्रतीक्षा करा...",
  "common.reseting": "पृष्ठाचा सामग्री रीसेट करत आहे... कृपया प्रतीक्षा करा...",
  "common.save": "सेव करा",
  "common.onlyNumberTips": "फक्त संख्या प्रविष्ट करू शकता",
  "common.offline": "ऑफलाइन",
  "common.online": "ऑनलाइन",
  "common.fault": "दोष",
  "common.charge": "चार्ज करणे",
  "common.discharge": "डिस्चार्ज करणे",
  "common.buy": "खरेदी करणे",
  "common.sell": "विक्री करणे",
  "common.loadingInfo": "लोड होत आहे... कृपया प्रतीक्षा करा...",

  // 
  "common.moreFeatures": "अधिक वैशिष्ट्ये",
  "common.confirm": "पुष्टी करा",
  "common.saveing": "सेव करत आहे... कृपया प्रतीक्षा करा...",
  "common.searchPlacholder": "शोधासाठी कीशवर्ड प्रविष्ट करा",
  "common.iSee": "मला समजले",
  "common.pageErrorTips1": "ओह, पृष्ठावर त्रुटी आली आहे~",
  "common.pageErrorTips2": "पृष्ठ रिफ्रेश करून प्रयत्न करा किंवा सपोर्टसह संपर्क साधा~",
  "common.refresh": "रिफ्रेश करा",
  "common.backToHome": "मुख्य पृष्ठावर परत जा",
  "common.checkTips": "चेक करत आहे... कृपया प्रतीक्षा करा...",
  "common.back": "परत जा",
  "common.cancel": "रद्द करा",
  "common.optional": "पर्यायी",
  "common.required": "आवश्यक",
  "common.status": "स्थिती",
  "common.statusNoDelete": "हटवले नाही",
  "common.statusDelete": "हटवले गेले",
  "common.submit": "सबमिट करा",
  "common.disable": "अक्षम करा",
  "common.enable": "सक्षम करा",
  "common.year": "वर्ष",
  "common.month": "महिना",
  "common.day": "दिवस",
  "common.version": "आवृत्ती:",
  "common.backHome": " मुख्य पृष्ठावर परत जा",
  "common.backHomeSorry": " क्षमस्वप्तुं, पृष्ठाचा अचानक मार्ग हरवला",
  "common.requestTips1": "डेटा प्रोसेसिंग करत आहे, पुन्हा सबमिट करू नका",
  "common.requestTips2": "सिस्टम सूचना",
  "common.requestTips3": "लॉगिन स्थिती कालसीमा ओलांडली आहे, पुन्हा लॉगिन करा",
  "common.requestTips4": "पुन्हा लॉगिन करा",
  "common.requestTips5": "अवैध सत्र किंवा सत्र कालसीमा ओलांडली आहे, पुन्हा लॉगिन करा.",
  "common.requestTips6": "सर्व्हरमध्ये त्रुटी, कृपया नंतर पुन्हा प्रयत्न करा.",
  "common.requestTips7": "सिस्टम इंटरफेसच्या विनंतीची कालसीमा ओलांडली आहे",
  "common.requestTips8": "सिस्टम इंटरफेस",
  "common.requestTips9": "दोष",
  "common.iknow": "मला समजले",
  "common.logoutSuccess": "लॉगआउट यशस्वी",
  
  // 了解更多组件
  "common.knowMore.title": "अधिक माहितीसाठी, बेइनेंगसह संपर्क साधा",
  "common.knowMore.email": "संपर्क इमेल",
  "common.knowMore.phone": "संपर्क फोन",
  "common.knowMore.wechat": "संपर्क व्हाट्सएप (WeChat)",
  "common.knowMore.website": "अधिकृत वेबसाइटचा पत्ता",
  "common.knowMore.address": "संपर्क पत्ता",
  "common.knowMore.addressDetail": "ग्वांगडोंग प्रांत, डोंगवान शहर, हुआंगजiang टाउन, हुआंगजिंगकेंग, किंगहे रोड 8, बिल्डिंग 5, रूम 1205 आणि 1301",
  
  // 本地连接组件
  "common.localConnection": "स्थानिक कनेक्शन",
  "common.operateInApp": "अॅपमध्ये ऑपरेट करा!",
  
  "common.enbleStaus": "सक्षमीकरण स्थिती",
  "common.battery.status": "चार्ज आणि डिस्चार्ज नाही",

  "account.forgetThePassword": "पासवर्ड विसरला",
  "account.logInDirectly": "थेट लॉगिन करा",
  "account.tips1": "पृष्ठावर पुनर्निर्देशित करत आहे... कृपया प्रतीक्षा करा...",
  "account.tips2": "प्रथम वापरकर्ता अटी वाचा आणि स्वीकारा!",
  "account.autoLogin": "ऑटो लॉगिन",
  "account.userLogin": "वापरकर्ता लॉगिन",
  "account.registerTips": "अभी तक खाते नाही? रजिस्टर करण्यासाठी येथे क्लिक करा",
  "account.userEmail": "वापरकर्ता नाव / इमेल",
  "account.userEmailTips": "वापरकर्ता नाव किंवा इमेल प्रविष्ट करा",
  "account.password": "पासवर्ड",
  "account.passwordTips": "पासवर्ड प्रविष्ट करा",
  "account.submit": "सबमिट करा",
  "account.submitTips": "सबमिट करत आहे... कृपया प्रतीक्षा करा...",
  "account.otherLoginTips": "किंवा दुसरा लॉगिन मार्ग निवडा",
  "account.userRegistration": "वापरकर्ता रजिस्ट्रेशन",
  "account.userName": "वापरकर्ता नाव",
  "account.userNameTips": "वापरकर्ता नाव प्रविष्ट करा",
  "account.emailTips1": "इमेल पत्ता प्रविष्ट करा",
  "account.emailTips2": "अवैध इमेल पत्ता फॉरमॅट",
  "account.phone": "फोन नंबर",
  "account.phoneTips1": "फोन नंबर प्रविष्ट करा",
  "account.phoneTips2": "अवैध फोन नंबर",
  "account.phoneTips3": "फोन नंबर प्रविष्ट करा",
  "account.passwordTips1": "पासवर्ड प्रविष्ट करा (6-30 वर्ण)",
  "account.passwordTips2": "अवैध पासवर्ड फॉरमॅट: पासवर्डमध्ये इंग्रजी अक्षरे, संख्या, अंडरस्कोर, डॅश आणि बिंदू असणे आवश्यक आहे, लांबी 6-12 वर्ण",
  "account.passwordTips3": "दोन प्रविष्ट केलेले पासवर्ड जुळत नाहीत, तपासा आणि पुन्हा प्रविष्ट करा!",
  "account.passwordTips4": "पासवर्ड प्रविष्ट करा: पासवर्डमध्ये इंग्रजी अक्षरे, संख्या, अंडरस्कोर, डॅश आणि बिंदू असणे आवश्यक आहे",
  "account.passwordTips5": "पासवर्ड पुष्टी करा",
  "account.passwordTips6": "पासवर्ड पुष्टी करा",
  "account.passwordTips7": "दोन प्रविष्ट केलेले पासवर्ड जुळत नाहीत, तपासा आणि पुन्हा प्रविष्ट करा!",
  "account.passwordTips8": "पासवर्ड पुष्टी करा",
  "account.passwordTips9": "अभिनंदन, रजिस्ट्रेशन यशस्वी!",
  "account.passwordTips10": "तुमचे वापरकर्ता नाव आहे:",
  "account.emailIs": "इमेल आहे:",
  "account.goToLoginPage": "s सेकंदांनंतर स्वयंचलितपणे लॉगिन पृष्ठावर पुनर्निर्देशित केले जाईल",
  "account.goLogin": "लॉगिन करा",
  "account.goRegister": "रजिस्टर करा",
  "account.loginSuccess": "लॉगिन यशस्वी",
  "account.email": "इमेल",
  "account.sologn": "तुमच्यासाठी वैशिष्ट्ययुक्त ऊर्जा योजना तयार करत आहोत",
  "account.pleaseAgree": "मी वाचले आहे आणि स्वीकारले आहे",
  "userAgreement.privacyPolicy": "गोपनीयता धोरण",

  "account.code": "सत्यापन कोड",
  "account.codeTips": "सत्यापन कोड प्रविष्ट करा",
  "account.codeTips2": "अवैध सत्यापन कोड",

    "account.inviteCodeTips": "कृपया आमंत्रण कोड प्रविष्ट करा",
    "account.inviteCodeHint": "आमंत्रण कोड मिळवण्यासाठी कृपया इंस्टॉलर किंवा देखभाल कर्मचाऱ्यांशी संपर्क साधा",
  "account.modifyPasswordByAccount": "खात्याद्वारे पासवर्ड बदला",
  "account.modifyPasswordByEmail": "इमेलाद्वारे पासवर्ड बदला",
  "account.getPasswordByAccount": "खात्याद्वारे पासवर्ड प्राप्त करा",
  "account.getPasswordByEmail": "इमेलाद्वारे पासवर्ड प्राप्त करा",

  "account.sendEmailTips": "सत्यापन कोड इमेलवर पाठविला गेला आहे, ते तपासा",
  "account.name": "खात्याचे नाव",
  "account.newPassword": "नवीन पासवर्ड",
  "account.confirmNewPassword": "नवीन पासवर्ड पुष्टी करा",
  "account.nameTips": "खात्याचे नाव प्रविष्ट करा",
  "account.passwordModifySuccess": "पासवर्ड बदल यशस्वी",
  "account.emailCode": "इमेल सत्यापन कोड",
  "account.emailCodeTips": "इमेल सत्यापन कोड प्रविष्ट करा",
  "account.emailCodeTips2": "अवैध इमेल सत्यापन कोड",
  "account.emailModifySuccess": "पासवर्ड बदल यशस्वी",
  "account.passworTips1": "तुमचा पासवर्ड यशस्वीपणे रीसेट केला गेला आहे!",
  "account.passwordTips11": "पासवर्ड पुष्टी करा",
  "account.passwordTips12": "नवीन पासवर्ड प्रविष्ट करा",
  "account.nickname": "वापरकर्ता टोपणाम",
  "account.modifyNickname": "वापरकर्ता टोपणाम बदला",
  "account.modifyNicknameSuccess": "वापरकर्ता टोपणाम बदल यशस्वी!",
  "account.nicknameTips": "वापरकर्ता टोपणाम प्रविष्ट करा",
  "account.nicknameError": "वापरकर्ता टोपणाम बदल अयशस्वी!",

  "account.login": "लॉगिन करा",
  "account.quickRegister": "द्रुत रजिस्ट्रेशन",
  "account.sendCode": "सत्यापन कोड पाठवा",
  "account.sendTips": "s सेकंदांनंतर पुन्हा पाठवू शकता",
  "account.sendEmailIng": "इमेल पाठवत आहे... कृपया प्रतीक्षा करा...",
  "account.emailNotEmpty": "इमेल पत्ता रिक्त नाही असणे आवश्यक",
  "account.registerAccount": "खाते रजिस्टर करा",
  "account.registerWelcome": "SusprSafe मध्ये रजिस्टर करण्यात स्वागत आहे",
  "account.usernameLimit": "वापरकर्ता नावाची सुरुवात अक्षराने हवी, आणि त्यात फक्त अक्षरे, संख्या आणि अंडरस्कोर असू शकतात, लांबी 5-15 वर्ण",

  "copyright.desc2": "वेबसाइट रजिस्ट्रेशन माहिती: ग्वांगडोंग ICP रजिस्ट्रेशन क्रमांक 2021169764",

  "editUserInfo.editUserInformation": "वापरकर्ता माहिती संपादित करा",
  "editUserInfo.modifyUsername": "वापरकर्ता नाव बदला",
  "editUserInfo.changePictures": "प्रोफाइल फोटो बदला",
  "editUserInfo.savePicturesSuccess": "वापरकर्ता प्रोफाइल फोटो यशस्वीपणे सेव केली गेली",
  "editUserInfo.saveError": "सेव अयशस्वी",
  "editUserInfo.pictureLimit": "फोटोचा आकार 2 MB पेक्षा कमी असणे आवश्यक",
  "editUserInfo.uploadPicture": "प्रोफाइल फोटो अपलोड करा",
  "editUserInfo.picturePreview": "प्रीव्ह्यू",
  
  "editUserInfo.bindPhoneNumber": "फोन नंबर बांधा",
  "editUserInfo.bindEmail": "इमेल बांधा",
  "editUserInfo.changePassword": "पासवर्ड बदला",

  "editUserInfo.notificationSettings": "सूचना सेटिंग्ज",
  "editUserInfo.editAccount": "वापरकर्ता खाते माहिती संपादित करा",
  "editUserInfo.waitBingting": "बांधत आहे... कृपया प्रतीक्षा करा...",
  "editUserInfo.collapse": "संकुचित करा",
  "editUserInfo.modifyBinding": "बाइंडिंग बदला",
  
  "editUserInfo.emailAddress": "इमेल पत्ता",
  "editUserInfo.tips1": "इमेल बांधणे यशस्वी",
  "editUserInfo.tips2": "सेव अयशस्वी",
  "editUserInfo.tips3": "इमेल सत्यापन कोड पाठवत आहे... कृपया प्रतीक्षा करा...",
  "editUserInfo.tips4": "सत्यापन कोड xxxx इमेलवर पाठविला गेला आहे, ते तपासा",
  "editUserInfo.tips5": "सत्यापन कोड पाठवणे अयशस्वी!",
  "editUserInfo.tips6": "फोन नंबर आधीच बांधला गेला आहे",
  "editUserInfo.tips7": "इमेल आधीच बांधला गेला आहे",
  "editUserInfo.emailTips1": "इमेल पत्ता प्रविष्ट करा",
  "editUserInfo.emailTips2": "अवैध इमेल पत्ता फॉरमॅट",
  "editUserInfo.emailTips3": "xxxx सेकंदांनंतर पुन्हा पाठवू शकता",
  "editUserInfo.emailTips4": "सत्यापन कोड पाठवा",
  "editUserInfo.emailTips5": "इमेल सत्यापन कोड रिक्त नाही असणे आवश्यक",
  "editUserInfo.emailTips6": "अवैध इमेल सत्यापन कोड",
  "editUserInfo.emailCode": "इमेल सत्यापन कोड",
  "editUserInfo.save": "सेव करा",

  "editUserInfo.phoneTips1": "फोन नंबर बांधणे यशस्वी",
  "editUserInfo.phoneTips2": "एसएमएस सत्यापन कोड पाठवत आहे... कृपया प्रतीक्षा करा...",
  "editUserInfo.phoneTips3": "एसएमएस सत्यापन कोड xxxx फोन नंबरावर पाठविला गेला आहे, ते तपासा",
  "editUserInfo.phoneTips4": "एसएमएस सत्यापन कोड पाठवणे अयशस्वी!",
  "editUserInfo.phoneTips5": "फोन नंबर प्रविष्ट करा",
  "editUserInfo.phoneTips6": "अवैध फोन नंबर फॉरमॅट",
  "editUserInfo.phoneTips7": "एसएमएस सत्यापन कोड पाठवा",
  "editUserInfo.phoneTips8": "एसएमएस सत्यापन कोड",
  "editUserInfo.phoneTips9": "एसएमएस सत्यापन कोड रिक्त नाही असणे आवश्यक",
  "editUserInfo.phoneTips10": "अवैध एसएमएस सत्यापन कोड",
  "editUserInfo.phone": "फोन नंबर",


  "editUserInfo.noticeTips1": "सूचना सेटिंग्ज प्राप्त करणे अयशस्वी!",
  "editUserInfo.noticeTips2": "सूचना सेटिंग्ज यशस्वीपणे सेव केल्या गेल्या!",
  "editUserInfo.noticeTips3": "बॅटरी पातळी कमी असल्याची सूचना",
  "editUserInfo.noticeTips4": "चार्जर चार्ज पूर्ण झाल्याची सूचना",
  "editUserInfo.errorNotification": "दोष सूचना",
  "editUserInfo.updateNotification": "अपडेट सूचना",
  "editUserInfo.monthlyStatisticsNotification": "मासिक आकडेवारी सूचना",
  "editUserInfo.notificationMethod": "प्राप्ती पद्धत",

  "editUserInfo.userNameTips1": "वापरकर्ता नाव यशस्वीपणे सेव केले गेले",
  "editUserInfo.userNameTips2": "वापरकर्ता नाव सेव करणे अयशस्वी",
  "editUserInfo.userNameTips3": "वापरकर्ता नाव प्रविष्ट करा",
  "editUserInfo.userNameTips4": "अवैध वापरकर्ता नाव फॉरमॅट: त्यात फक्त संख्या, अंडरस्कोर आणि इंग्रजी अक्षरे असणे आवश्यक",
  "editUserInfo.userNameTips5": "वापरकर्ता नाव प्रविष्ट करा",
  "editUserInfo.userNameTips6": "सेव करत आहे... कृपया प्रतीक्षा करा...",
  "editUserInfo.userName": "वापरकर्ता नाव",

  "editUserInfo.avatorTips": "प्रोफाइल फोटो बदलण्यासाठी क्लिक करा",
  "editUserInfo.verifyCodeTips1": "प्राप्त केलेला सत्यापन कोड प्रविष्ट करा:",
  "editUserInfo.verifyCodeTips2": "तुमच्या खात्याच्या सुरक्षिततेसाठी मूळ फोन नंबरावर सत्यापन कोड पाठवण्यासाठी खालील बटणावर क्लिक करा:",
  "editUserInfo.verifyCodeTips3": "सत्यापन कोड पाठवा",
  "editUserInfo.verifyCodeTips4": "मूळ फोन सत्यापन यशस्वी आहे, नवीन बांधलेला फोन नंबर प्रविष्ट करा",
  "editUserInfo.verifyCodeTips5": "तुमच्या खात्याच्या सुरक्षिततेसाठी मूळ इमेलवर सत्यापन कोड पाठवण्यासाठी खालील बटणावर क्लिक करा:",
  "editUserInfo.verifyCodeTips6": "मूळ इमेल सत्यापन यशस्वी आहे, नवीन इमेल प्रविष्ट करा",
  "editUserInfo.verifyCodeTips7": "जुना पासवर्ड",
  "editUserInfo.verifyCodeTips8": "प्रथम इमेल बांधा!",
  "editUserInfo.verifyCodeTips9": "सत्यापन कोड इमेलवर पाठविला गेला आहे, ते तपासा",
  "editUserInfo.verifyCodeTips10": ", स्वयंचलितपणे लॉगिन पृष्ठावर पुनर्निर्देशित केले जाईल",

  "hems.notice.title": "सूचना शीर्षक", 
  "hems.notice.content": "सूचना सामग्री", 
  "hems.notice.operate": "ऑपरेशन",
  "hems.notice.noRead": "अवाचित",
  "hems.notice.read": "वाचित",
  "hems.notice.warning": "चेतावणी",
  "hems.notice.error": "दोष",
  "hems.notice.success": "आकडेवारी समेट",
  "hems.notice.sys": "सिस्टम माहिती",
  "hems.notice.operateSuccess": "ऑपरेशन यशस्वी",
  "hems.notice.operateTips": "ऑपरेशनसाठी आयटम निवडा",

  // 首页
  "hems.home.selfuseRate": "स्वयंप्रयोग दर",
  "hems.home.percent": "टक्का",
  "hems.home.todayData": "आजचे डेटा",
  "hems.home.todayPowerGeneration": "आजची ऊर्जा उत्पादन",
  "hems.home.salesIncome": "ऊर्जा विक्री उत्पन्न",
  "hems.home.saved": "तुम्ही वाचवले आहे",
  "hems.home.reduce": "कार्बन फुटप्रिंट कमी करा",
  "hems.home.tips1": "सध्या डेटा उपलब्ध नाही, तुम्ही अद्याप xxxx बांधले नाही",
  "hems.home.criticalLoad": "गंभीर लोड",
  "hems.home.keyVoltage": "गंभीर व्होल्टेज",
  "hems.home.householdLoad": "घराचा लोड",
  "hems.home.householdVoltage": "घराचा व्होल्टेज",
  "hems.home.generalLoad": "सामान्य लोड",
  "hems.home.generalVoltage": "सामान्य व्होल्टेज",
  "hems.home.batteryHealth": "बॅटरी आरोग्य स्थिती",
  "hems.home.averageTemp": "सरासरी तापमान",
  "hems.home.gridLoad": "विद्युत जाळीचा लोड",
  "hems.home.toggeleDataSource": "सध्या प्रदर्शित होणारे डेटा बदलले गेले आहेत:",
  "hems.home.toggleTips": "तुम्हाला खात्री आहे की तुम्हाला बदलायचा आहे?",
  "hems.home.modeSending": "मोड कमांड पाठवत आहे... कृपया प्रतीक्षा करा...",
  "hems.home.modeSuccess": "मोड बदल कमांड यशस्वीपणे पाठविली गेली!",
  "hems.home.isOnline": "ऑनलाइन आहे का?",
  "hems.home.useStatus": "वापर स्थिती",
  "hems.home.workModeText": "सध्याचा कार्य मोड:",
  "hems.home.toggleDataSourceText": "सध्या प्रदर्शित होणारे डेटा बदलले गेले आहेत:",
  "hems.ev.charge.status": "चार्ज स्थिती",
  "hems.ev.charge.time": "चार्ज वेळ",
  "hems.ev.charge.count": "वास्तविक वेळची चार्ज मात्रा",
  "hems.ev.charge.status.empty": "रिक्त",
  "hems.ev.charge.status.ing": "केबल जोडलेले आणि चार्ज होत आहे",
  "hems.ev.charge.status.null": "केबल जोडलेले परंतु चार्ज होत नाही",
  "hems.ev.charge.status.error": "दोष",
  "hems.hour": "तास",
  "hems.minue": "मिनिट",
  "hems.ev.chagre.number": "चार्जर क्रमांक",

  // User Guide
  "hems.userGuide.selfUse": "स्वयंउत्पादित ऊर्जा स्वयंप्रयोग",
  "hems.userGuide.selfUseTips": "प्रथम फोटोवोल्टिक ऊर्जा वापरा, जर अपुरी असेल तर विद्युत जाळीतून पूर्ण करा",
  "hems.userGuide.economyMode": "आर्थिक मोड",
  "hems.userGuide.economyModeTips": "विद्युत किमतीनुसार ऊर्जा वापराची रणनीती इष्टतम करा",
  "hems.userGuide.emergencyMode": "आपत्कालीन मोड",
  "hems.userGuide.emergencyModeTips": "प्रथम गंभीर लोडच्या ऊर्जा पुरवठ्याची खात्री करा",

  // 图表页面
  "hems.history.energyStatistics": "ऊर्जा आकडेवारी",
  "hems.history.revenueStatistics": "उत्पन्न आकडेवारी",
  "hems.history.greenStatistics": "हिरवी उत्सर्जन कमी करणे",
  "hems.history.revenueTitle": "ऊर्जा विक्रीचे एकूण उत्पन्न",
  "hems.history.savingsTitle": "एकूण वाचती",
  "hems.history.carbonTitle": "कार्बन उत्सर्जन कमी करण्याची एकूण मात्रा",
  "hems.history.day": "दिवस",
  "hems.history.month": "महिना",
  "hems.history.year": "वर्ष",
  "hems.history.beforeDay": "पूर्वीचा दिवस",
  "hems.history.afterDay": "पुढील दिवस",
  "hems.history.beforeMonth": "पूर्वीचा महिना",
  "hems.history.afterMonth": "पुढील महिना",
  "hems.history.beforeYear": "पूर्वीचे वर्ष",
  "hems.history.afterYear": "पुढील वर्ष",
  "hems.history.totalUse": "एकूण वापर",
  "hems.history.fullScreen": "पूर्ण स्क्रीन",
  "hems.history.timeSelect": "तारीख निवडा",
  "sync.tips1": "डेटा सिंक्रोनायझेशन कमांड यशस्वीपणे पाठविली गेली!",
  "sync.tips2": "डेटा सिंक्रोनायझेशन होत आहे, डेटाच्या मोठ्या प्रमाणामुळे वेळ लागेल, अर्ध्या तासानंतर पुन्हा तपासा~",
  "sync.tips3": "डिवाइस डेटा सिंक्रोनायझेशनमध्ये विलंब होऊ शकतो, जर तुम्हाला डेटामध्ये विसंगती आढळली तर, येथे क्लिक करा:",
  "sync.tips4": "डेटा सिंक्रोनाइझ करा",

  "charge.info": "चार्जर माहिती",
  "news.loading": "लोड होत आहे...",
  "news.noMore": "आधिक डेटा नाही",
  "hems.pv.power": "फोटोवोल्टिक ऊर्जा मात्रा",

  // UEH specific
  "ueh.sellPower": "विक्री केलेली ऊर्जा मात्रा",
  
  "menu.home": "मुख्य पृष्ठ",
  "menu.history": "इतिहासिक डेटा",
  "menu.device": "डिवाइसेस",
  "menu.settings": "सेटिंग्ज",
  "menu.messageCenter": "संदेश केंद्र",
  "menu.help": "सहाय्य आणि सपोर्ट",
  "menu.mine": "माझे",


  "mine.userSetting": "वापरकर्ता सेटिंग्ज",
  "mine.terminalSetting": "टर्मिनल मूळ सेटिंग्ज",
  "mine.uploadCloud": "क्लाउडमध्ये डेटा अपलोड करा",
  "mine.changeVersion": "अपडेट तपासा",
  "mine.language": "भाषा बदला",
  "mine.about": "अॅपबद्दल",
  "mine.feedback": "फीडबॅक",
  "mine.logout": "लॉगआउट करा",
  "mine.logoutAccount": "खाते हटवा",

  "mine.logoutAccountTips": "[ ] नावाचे खाते हटवा",
  "mine.logoutAccountTips1": "[ ]शी बांधलेले खाते हटवा",
  "mine.logoutAccountCare": "खाते हटवण्याच्या विनंतीसंबंधी टिप्स:",
  "mine.logoutAccountCare1": "1. खाते सुरक्षित स्थितीत आहे",
  "mine.logoutAccountCare1-1": "खाते सामान्य वापर स्थितीत आहे, चोरीण्याचा, नियम तोडण्याचा किंवा ब्लॉक करण्याचा जोखीम नाही.",
  "mine.logoutAccountCare2": "2. खात्याच्या अधिकार आणि बाइंडिंग्स काढले गेले आहेत",
  "mine.logoutAccountCare2-1": "तृतीय पक्षाच्या प्लॅटफॉर्मसह खात्याचे सर्व अधिकार काढले गेले आहेत.",
  "mine.logoutAccountCare3": "3. खाते हटवल्यानंतर ते पुनर्संचयित करणे शक्य नाही, वापरकर्ता डेटा हटवले जातील",
  "mine.logoutAccountCare3-1": "खाते हटवल्यानंतर, बांधलेला फोन नंबर, इमेल आणि इतर डेटा हटवले जातील आणि पुनर्संचयित करणे शक्य नाही.",
  "mine.confirmLogout": "हटवणे पुष्टी करा",
  "mine.logoutSuccess": "खाते यशस्वीपणे हटवले गेले!",


  "mine.feedbackIssues": "समस्यांचे फीडबॅक",
  "mine.feedQuantity": "मात्रा",
  "mine.feedAmount": "कमाल 9 फोटो, कमाल आकार 1 MB/फोटो",

  "mine.notice.fail": "सूचना सेटिंग्ज प्राप्त करणे अयशस्वी!",
  "mine.notice.saveSuccess": "सूचना सेटिंग्ज यशस्वीपणे सेव केल्या गेल्या!",
  "mine.notice.saveFail": "सेव अयशस्वी!",
  "mine.notice.title": "सूचना सेटिंग्ज",
  "mine.notice.batteryLow": "बॅटरी पातळी कमी असल्याची सूचना",
  "mine.notice.chargingFinish": "चार्जर चार्ज पूर्ण झाल्याची सूचना",
  "mine.notice.error": "दोष सूचना",
  "mine.notice.update": "अपडेट सूचना",
  "mine.notice.monthly": "मासिक आकडेवारी सूचना",
  "mine.notice.receiveType": "प्राप्ती पद्धत",

  "mine.language.welcome": "SusprSafe मध्ये स्वागत आहे",
  "mine.language.desc1": "तुमच्या राहिल्याच्या ठिकाणानुसार भाषा आवृत्ती निवडा",
  "mine.language.desc2": "तुम्हाला अॅपच्या सेटिंग्जमध्ये कोणत्याही वेळी बदलू शकता",

  "mine.userInfo.avatar": "प्रोफाइल फोटो",
  "mine.userInfo.nickname": "टोपणाम",
  "mine.userInfo.password": "पासवर्ड",
  "mine.userInfo.changePassword": "पासवर्ड बदला",
  "mine.userInfo.setPassword": "पासवर्ड सेट करा",
  "mine.userInfo.phoneNumber": "फोन नंबर",
  "mine.userInfo.bindPhone": "फोन नंबर बांधा",
  "mine.userInfo.bindEmail": "इमेल बांधा",
  "mine.loginExpired": "लॉगिन स्थिती कालसीमा ओलांडली आहे, पुन्हा लॉगिन करा",
  "mine.userInfo.title": "वापरकर्ता माहिती",
  "mine.userInfo.bind": "बांधा",
  "mine.userInfo.modify": "संपादित करा",
  "mine.userInfo.modifyNickname": "टोपणाम बदला",
  "mine.userInfo.userNickname": "वापरकर्ता टोपणाम",
  "mine.userInfo.selectPic": "अपलोड करण्यासाठी फोटो निवडा",
  "mine.userInfo.saveSuccess": "सेव यशस्वी",
  "mine.userInfo.uploadFail": "अपलोड अयशस्वी",
  "mine.userInfo.avatarSaveSuccess": "प्रोफाइल फोटो यशस्वीपणे सेव केली गेली",
  "mine.userInfo.nameTips1": "वापरकर्ता टोपणाम रिक्त नाही असणे आवश्यक",
  "mine.userInfo.nameTips2": "वापरकर्ता टोपणाम प्रविष्ट करा",

  "common.pleaseSelect": "कृपया निवडा",
  "question.commonQuestions": "सामान्य प्रश्न",
  "account.toggleLanguage": "भाषा बदला",
  "account.localConnection": "स्थानिक कनेक्शन",
  "account.selectLanguage": "कृपया भाषा निवडा",
  "account.sendEmailToast": "सत्यापन कोड xxx इमेलवर पाठविला गेला आहे, ते तपासा",
  "account.emailError": "अवैध इमेल फॉरमॅट",
  "account.sendEmailFail": "पाठवणे अयशस्वी, पुन्हा प्रयत्न करा",
  
  "common.submitting": "सबमिट करत आहे... कृपया प्रतीक्षा करा...",

  "device.page.noData": "सध्या डेटा उपलब्ध नाही, हा पृष्ठ फक्त अॅपमध्ये पाहिला जाऊ शकतो"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};